import React from "react";
import { cn } from "@/lib/utils";
import { Loader2 } from "lucide-react";

interface LoadingSpinnerProps {
  size?: "sm" | "md" | "lg";
  className?: string;
  text?: string;
  variant?: "default" | "dots" | "pulse";
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = "md",
  className,
  text,
  variant = "default",
}) => {
  const sizeStyles = {
    sm: "h-4 w-4",
    md: "h-6 w-6",
    lg: "h-8 w-8",
  };

  if (variant === "dots") {
    return (
      <div className={cn("flex justify-center items-center", className)}>
        <div className="flex space-x-1">
          {[...Array(3)].map((_, i) => (
            <div
              key={i}
              className={cn(
                "bg-current rounded-full animate-pulse",
                size === "sm"
                  ? "h-1 w-1"
                  : size === "md"
                  ? "h-2 w-2"
                  : "h-3 w-3"
              )}
              style={{
                animationDelay: `${i * 0.2}s`,
                animationDuration: "1s",
              }}
            />
          ))}
        </div>
        {text && <span className="ml-2 text-sm">{text}</span>}
      </div>
    );
  }

  if (variant === "pulse") {
    return (
      <div className={cn("flex justify-center items-center", className)}>
        <div
          className={cn(
            "rounded-full bg-current animate-pulse",
            sizeStyles[size]
          )}
        />
        {text && <span className="ml-2 text-sm">{text}</span>}
      </div>
    );
  }

  return (
    <div className={cn("flex justify-center items-center", className)}>
      <Loader2 className={cn("animate-spin", sizeStyles[size])} />
      {text && <span className="ml-2 text-sm">{text}</span>}
    </div>
  );
};
